"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const RedeemActions_1 = __importDefault(require("../actions/RedeemActions"));
const Url_1 = __importDefault(require("../constants/Url"));
const axios_1 = __importDefault(require("axios"));
const common_1 = require("@epic-core/common");
const window_or_global_1 = __importDefault(require("window-or-global"));
/**
 * RedeemSource
 *
 * Ajax calls for Orion code redemption data
 *
 * For more information on source usage:
 * http://alt.js.org/docs/async/
 *
 */
const xhr = {
    getHeader() {
        return {
            'X-Requested-With': 'XMLHttpRequest',
            'X-EPIC-RETURN-JSON-IF-NO-AUTH': true,
            'Accept-Language': common_1.getLocale()
        };
    },
    postHeader() {
        return {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept-Language': common_1.getLocale()
        };
    }
};
const RedeemSource = {
    validateCode: {
        remote(state) {
            return axios_1.default({
                headers: xhr.postHeader(),
                method: 'post',
                url: Url_1.default().REDEEM.VALIDATE,
                data: `codeId=${encodeURIComponent(state.redeemCode)}&captchaToken=${state.captchaToken}&locale=${encodeURIComponent(common_1.getLocale())}`
            });
        },
        success: RedeemActions_1.default.validateCodeSuccess,
        error: RedeemActions_1.default.validateCodeFailure,
        shouldFetch() {
            return !window_or_global_1.default.__server_side_render;
        }
    },
    redeemCode: {
        remote(state, data) {
            return axios_1.default({
                headers: xhr.postHeader(),
                method: 'post',
                url: Url_1.default().REDEEM.SUBMIT,
                data: `hostPageId=${encodeURIComponent(data.hostPageId)}&codeId=${encodeURIComponent(data.redeemCode)}&captchaToken=${state.captchaToken}&locale=${encodeURIComponent(common_1.getLocale())}`
            });
        },
        success: RedeemActions_1.default.redeemCodeSuccess,
        error: RedeemActions_1.default.redeemCodeFailure,
        shouldFetch() {
            return !window_or_global_1.default.__server_side_render;
        }
    },
    clearEntitlementsFromSession: {
        remote() {
            return axios_1.default.get(Url_1.default().REDEEM.CLEARENTITLEMENTS);
        },
        success: RedeemActions_1.default.clearEntitlementsFromSessionSuccess,
        error: RedeemActions_1.default.clearEntitlementsFromSessionFailure,
        shouldFetch() {
            return !window_or_global_1.default.__server_side_render;
        }
    }
};
exports.default = RedeemSource;
//# sourceMappingURL=RedeemSource.js.map